import { createAction } from '@reduxjs/toolkit';

export const addToBreadcrumbs = createAction('breadcrumbs/addToBreadcrumbs');
